/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createSysParam } from '../fn/sys-param-controller/create-sys-param';
import { CreateSysParam$Params } from '../fn/sys-param-controller/create-sys-param';
import { deleteSysParam } from '../fn/sys-param-controller/delete-sys-param';
import { DeleteSysParam$Params } from '../fn/sys-param-controller/delete-sys-param';
import { getSysParam } from '../fn/sys-param-controller/get-sys-param';
import { GetSysParam$Params } from '../fn/sys-param-controller/get-sys-param';
import { getSysParams } from '../fn/sys-param-controller/get-sys-params';
import { GetSysParams$Params } from '../fn/sys-param-controller/get-sys-params';
import { getSysParamsFiltered } from '../fn/sys-param-controller/get-sys-params-filtered';
import { GetSysParamsFiltered$Params } from '../fn/sys-param-controller/get-sys-params-filtered';
import { PageSysParamDto } from '../models/page-sys-param-dto';
import { SysParamDto } from '../models/sys-param-dto';
import { updateSysParam } from '../fn/sys-param-controller/update-sys-param';
import { UpdateSysParam$Params } from '../fn/sys-param-controller/update-sys-param';

@Injectable({ providedIn: 'root' })
export class SysParamControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSysParam()` */
  static readonly GetSysParamPath = '/v1/sysparams/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSysParam()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSysParam$Response(params: GetSysParam$Params, context?: HttpContext): Observable<StrictHttpResponse<SysParamDto>> {
    return getSysParam(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSysParam$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSysParam(params: GetSysParam$Params, context?: HttpContext): Observable<SysParamDto> {
    return this.getSysParam$Response(params, context).pipe(
      map((r: StrictHttpResponse<SysParamDto>): SysParamDto => r.body)
    );
  }

  /** Path part for operation `updateSysParam()` */
  static readonly UpdateSysParamPath = '/v1/sysparams/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSysParam()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSysParam$Response(params: UpdateSysParam$Params, context?: HttpContext): Observable<StrictHttpResponse<SysParamDto>> {
    return updateSysParam(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSysParam$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSysParam(params: UpdateSysParam$Params, context?: HttpContext): Observable<SysParamDto> {
    return this.updateSysParam$Response(params, context).pipe(
      map((r: StrictHttpResponse<SysParamDto>): SysParamDto => r.body)
    );
  }

  /** Path part for operation `deleteSysParam()` */
  static readonly DeleteSysParamPath = '/v1/sysparams/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSysParam()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSysParam$Response(params: DeleteSysParam$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteSysParam(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSysParam$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSysParam(params: DeleteSysParam$Params, context?: HttpContext): Observable<void> {
    return this.deleteSysParam$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getSysParams()` */
  static readonly GetSysParamsPath = '/v1/sysparams';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSysParams()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSysParams$Response(params?: GetSysParams$Params, context?: HttpContext): Observable<StrictHttpResponse<PageSysParamDto>> {
    return getSysParams(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSysParams$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSysParams(params?: GetSysParams$Params, context?: HttpContext): Observable<PageSysParamDto> {
    return this.getSysParams$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageSysParamDto>): PageSysParamDto => r.body)
    );
  }

  /** Path part for operation `createSysParam()` */
  static readonly CreateSysParamPath = '/v1/sysparams';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSysParam()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSysParam$Response(params: CreateSysParam$Params, context?: HttpContext): Observable<StrictHttpResponse<SysParamDto>> {
    return createSysParam(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSysParam$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSysParam(params: CreateSysParam$Params, context?: HttpContext): Observable<SysParamDto> {
    return this.createSysParam$Response(params, context).pipe(
      map((r: StrictHttpResponse<SysParamDto>): SysParamDto => r.body)
    );
  }

  /** Path part for operation `getSysParamsFiltered()` */
  static readonly GetSysParamsFilteredPath = '/v1/sysparams/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSysParamsFiltered()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getSysParamsFiltered$Response(params: GetSysParamsFiltered$Params, context?: HttpContext): Observable<StrictHttpResponse<PageSysParamDto>> {
    return getSysParamsFiltered(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSysParamsFiltered$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getSysParamsFiltered(params: GetSysParamsFiltered$Params, context?: HttpContext): Observable<PageSysParamDto> {
    return this.getSysParamsFiltered$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageSysParamDto>): PageSysParamDto => r.body)
    );
  }

}
